module.exports = __webpack_public_path__ + "img/Arts-Music-Page-Alligator.fc58bab2.svg";